import { Flex } from '@smarterservices/smarter-ui';
import PhotoUploader from '../PhotoUploader';
import './index.css';
import DualPane from '../DualPane';
import StepInstructions from '../Common/StepInstructions';

const SelfiePhoto = ({ stepData, setIsTaskComplete }) => {
  return (
    <DualPane
      leftPane={
        <StepInstructions instructions={stepData?.body} />
      }
      rightPane={
        <Flex direction="column" padding="medium" alignItems="center">
          <PhotoUploader
            photoType="headshot"
            setIsTaskComplete={setIsTaskComplete}
            stepData={stepData}
          />
        </Flex>
      }
    />
  );
};

export default SelfiePhoto;
